import * as a from "react";
import m from "../lib/IconBase.es.js";
import s from "../defs/VideoCameraSlash.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(m, { ref: r, ...o, weights: s }));
e.displayName = "VideoCameraSlashIcon";
const c = e;
export {
  c as VideoCameraSlash,
  e as VideoCameraSlashIcon
};
